import { render, staticRenderFns } from "./ProductDetailEng.vue?vue&type=template&id=5555639e&"
import script from "./ProductDetailEng.vue?vue&type=script&lang=js&"
export * from "./ProductDetailEng.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailEng.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports